
import { Component, OnInit, Inject, ElementRef, NgZone, ViewChild } from '@angular/core';
import { DealershipService } from '../services/dealership.service';
import { DealershipOverview, NewDealership, Report, DealerGroupV } from '../models/dealership.model';
import { FormControl } from '@angular/forms';
// import { } from 'googlemaps';

import { NotificationsService } from 'angular2-notifications';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'add-dealership-modal',
    templateUrl: './add-dealership-modal.component.html',
    styleUrls: ['./add-dealership-modal.component.scss']
})
export class AddDealershipModalComponent implements OnInit {
    dealershipName: string = '';
    savingNewDealership: boolean = false;
    dealergroups: DealerGroupV[];
    selectedDealerGroupId: number = 0;
    dropdownList = [];
    ropedropdownList=[];
    weardropdownList=[];
    wsredropdownList=[];

    dropdownSettings = {};
    ropedropdownSettings={};
    weardropdownSettings={};
    wsredropdownSettings={};

    selectedItems = [];
    ropeselectedItems = [];
    wearselectedItems = [];
    wsreselectedItems = [];


    selectedQuoteStyles = [];
    quoteReportSetting = {};
    availableQuoteReportStyles = [];


    address1:string;
    address2:string;
    phone:string;
    suburb:string;
    postCode:string;
    state:string;
    email:string;
    constructor(public dialogRef: MatDialogRef<AddDealershipModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
        private _dealershipService: DealershipService, public snackBar: MatSnackBar, private _notifications: NotificationsService) { }

    ngOnInit() {
        // this._dealershipService.getAllReportTypes().subscribe(result => {
        //     result.forEach(r => {
        //         this.dropdownList.push({
        //             "id": r.ReportId,
        //             "itemName": r.ReportName
        //         });
        //     });
        // });

        this._dealershipService.getAllRopeShovelReportTypes().subscribe(result => {
            // result.forEach(r => {
            //     this.ropedropdownList.push({
            //         "id": r.ReportId,
            //         "itemName": r.ReportName
            //     });
            // });
            this.ropedropdownList = result;
        });

        this._dealershipService.getAllGetWearReportTypes().subscribe(result => {
            // result.forEach(r => {
            //     this.weardropdownList.push({
            //         "id": r.ReportId,
            //         "itemName": r.ReportName
            //     });
            // });
            this.weardropdownList = result;
        });

        this._dealershipService.getAllWsreReportTypes().subscribe(result => {
            // result.forEach(r => {
            //     this.wsredropdownList.push({
            //         "id": r.ReportId,
            //         "itemName": r.ReportName
            //     });
            // });
            this.wsredropdownList = result;
        });

        this._dealershipService.getAllQuoteReportStyles().subscribe(result=>{
            this.availableQuoteReportStyles = result;
            // result.forEach(r => {
            //     // this.availableQuoteReportStyles.push({
            //     //     "id": r.ReportId,
            //     //     "itemName": r.ReportName
            //     // });
            // });
        });

        this._dealershipService.getAllDealerGroups().subscribe(result => {
            this.dealergroups = result;
            if (this.dealergroups.length > 0) {
                this.selectedDealerGroupId = this.dealergroups[0].Id;

                this._dealershipService.getAllReportTypesByDealerGroupId(this.selectedDealerGroupId).subscribe(result => {
                    // result.forEach(r => {
                    //     this.dropdownList.push({
                    //         "id": r.ReportId,
                    //         "itemName": r.ReportName
                    //     });
                    // });
                    this.dropdownList = result;
                });
            }
        });
        this.dropdownSettings = {
            singleSelection: false,
            text: "Select Report Styles",
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            enableSearchFilter: true,
            classes: "multiselect-dropdown",
            maxHeight: 150
        };

        this.ropedropdownSettings = {
            singleSelection: false,
            text: "Select Rope Shovel Report Styles",
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            enableSearchFilter: true,
            classes: "multiselect-dropdown",
            maxHeight: 150
        };

        this.weardropdownSettings = {
            singleSelection: false,
            text: "Select GET Wear Surface Report Styles",
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            enableSearchFilter: true,
            classes: "multiselect-dropdown",
            maxHeight: 150
        };

        this.wsredropdownSettings = {
            singleSelection: false,
            text: "Select WSRE Report Styles",
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            enableSearchFilter: true,
            classes: "multiselect-dropdown",
            maxHeight: 150
        };
        this.quoteReportSetting = {
            singleSelection: false,
            text: "Select Quote Report Styles",
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            enableSearchFilter: true,
            classes: "multiselect-dropdown",
            maxHeight: 150
        };
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    dealerGroupSelected(dealerGroupId:number) {
        this.dropdownList = []; 
        this._dealershipService.getAllReportTypesByDealerGroupId(dealerGroupId).subscribe(result => {
            result.forEach(r => {
                this.dropdownList.push({
                    "ReportId": r.ReportId,
                    "ReportName": r.ReportName
                });
            });
        });
    }

    addNewDealership() {
        if (this.savingNewDealership)
            return;
        if (this.dealershipName.length < 1 || this.selectedItems.length < 1) {
            this.snackBar.open('Please fill in all required fields (*)', '', {
                duration: 1500,
            });
            return;
        }
        if (this.selectedDealerGroupId < 1) {
            this.snackBar.open('Please select dealer group!', '', {
                duration: 1500,
            });
            return;
        }
        this.savingNewDealership = true;
        let reportStyles: Report[] = [];

        this.selectedItems.forEach(i => {
            reportStyles.push({
                // ReportId: i.id,
                // ReportName: i.itemName
                ReportId: i,
                ReportName: ""
            });
        });


        let ropereportStyles: Report[] = [];

        this.ropeselectedItems.forEach(i => {
            ropereportStyles.push({
                // ReportId: i.id,
                // ReportName: i.itemName
                ReportId: i,
                ReportName: ""
            });
        });

        let wearreportStyles: Report[] = [];

        this.wearselectedItems.forEach(i => {
            wearreportStyles.push({
                // ReportId: i.id,
                // ReportName: i.itemName
                ReportId: i,
                ReportName: ""
            });
        });

        let wsrereportStyles: Report[] = [];

        this.wsreselectedItems.forEach(i => {
            wsrereportStyles.push({
                // ReportId: i.id,
                // ReportName: i.itemName
                ReportId: i,
                ReportName: ""
            });
        });

        let quoteReportStyles: Report[] = [];
        this.selectedQuoteStyles.forEach(s => {
            quoteReportStyles.push({
                // ReportId:s.id,
                // ReportName: s.itemName
                ReportId:s,
                ReportName: ""
            });

        })
        let newDealership: NewDealership = {
            DealershipName: this.dealershipName,
            ReportStyles: reportStyles,
            DealerGroupId : this.selectedDealerGroupId,
            QuoteReportStyles: quoteReportStyles,
            RopeReportStyles:ropereportStyles,
            WearReportStyles:wearreportStyles,
            WsreReportStyles:wsrereportStyles,

            phone:this.phone,
            address1:this.address1,
            address2:this.address2,
            suburb:this.suburb,
            postcode:this.postCode,
            state:this.state,
            email:this.email,
        }
        this._dealershipService.addNewDealership(newDealership).subscribe(result => {
            this.savingNewDealership = false;
            if (!(result > 0)) {
                this._notifications.error('Failed', 'A dealership with this name already exists. ');
            } else {
                this._notifications.success('Dealership Added', 'This dealership has been added successfully. ');
                this.dialogRef.close(true);
            }
        });
    }

    Validate(event:any) {
        var regex = new RegExp("^[0-9-()+ ]");
        var key = String.fromCharCode(event.charCode ? event.which : event.charCode);
        if (!regex.test(key)) {
            event.preventDefault();
            return false;
        }
    } 
}
